import React from "react";
import "./AfterContent.css";
import { RandomTime } from "../../../components/smiWidgets/RandomTime";
import { useVisibilityTracker } from "../../../utils/visibilityTracker";

export function AfterContent({ jsonData, objectId, showId }) {
    if (!jsonData) {
        return null;
    }

    return (
        <div className="after-content">
            {jsonData.map((item) => {
                const visibilityRef = useVisibilityTracker(
                    item.id,
                    objectId,
                    "AfterContent",
                    jsonData.length,
                    showId,
                    item.cid,
                    item.crid,
                    item.bidder_id,
                    item.bidder_cid,
                    item.eventtrackers,
                    item
                );
                return (
                    <a key={item.id} href={item.url} target="_blank" ref={visibilityRef}>
                        <div className="after-content-block">
                            <img src={item.img} alt={item.title} />
                            <div className="after-content-title">
                                <h2>{item.title}</h2>
                                <RandomTime />
                            </div>
                        </div>
                    </a>
                );
            })}
        </div>
    );
}
